import React from "react";

const StudentModeSelector = ({ studentsState, onUpdate }) => {
  const mode = studentsState?.type || "studentGroups";

  const handleToggleMode = (newMode) => {
    if (mode !== newMode) {
      onUpdate({ type: newMode });
    }
  };

  return (
    <div className="space-y-4">
      <div className="text-xl mb-[-10px]">Which students are attending?</div>



      {/* Toggle between group vs individual mode */}
      {!studentsState.noStudentsAttending && !studentsState.notYetConfirmed && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Select students in attendance by:
          </label>
          <div className="flex gap-4 text-sm">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="studentMode"
                checked={mode === "studentGroups"}
                onChange={() => handleToggleMode("studentGroups")}
              />
              Student groups
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="studentMode"
                checked={mode === "customList"}
                onChange={() => handleToggleMode("customList")}
              />
              Individual students
            </label>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentModeSelector;
